const mockTestGroups = [
    {
        id: 'TG001',
        name: 'Authentication Suite',
        description:
            'Complete authentication and authorization test scenarios including login, logout, password reset, and session management',
        groupType: 'Static',
        testCaseCount: 15,
        launchCount: 42,
        scheduledToRun: 'Yes',
        executionStatus: {
            passed: 13,
            failed: 2,
            pending: 0,
            overall: 'Mixed',
        },
        lastRunDate: '2024-01-15 14:30:25',
        nextRunDate: '2024-01-16 09:00:00',
        createdBy: 'John Doe',
        module: 'Authentication',
    },
    {
        id: 'TG002',
        name: 'Payment Processing',
        description:
            'End-to-end payment flow testing including credit card processing, payment gateway integration, and transaction validation',
        groupType: 'Dynamic',
        testCaseCount: 23,
        launchCount: 18,
        scheduledToRun: 'No',
        executionStatus: {
            passed: 18,
            failed: 5,
            pending: 0,
            overall: 'Mixed',
        },
        lastRunDate: '2024-01-14 16:45:12',
        nextRunDate: '-',
        createdBy: 'Jane Smith',
        module: 'Payments',
    },
    {
        id: 'TG003',
        name: 'User Profile Management',
        description:
            'User profile operations including profile creation, updates, image uploads, and account settings management',
        groupType: 'Static',
        testCaseCount: 12,
        launchCount: 35,
        scheduledToRun: 'Yes',
        executionStatus: {
            passed: 12,
            failed: 0,
            pending: 0,
            overall: 'Passed',
        },
        lastRunDate: '2024-01-13 11:20:08',
        nextRunDate: '2024-01-17 10:30:00',
        createdBy: 'Mike Johnson',
        module: 'User Management',
    },
    {
        id: 'TG004',
        name: 'API Security Tests',
        description:
            'Comprehensive API security testing including rate limiting, authentication, authorization, and input validation',
        groupType: 'Dynamic',
        testCaseCount: 18,
        launchCount: 7,
        scheduledToRun: 'No',
        executionStatus: {
            passed: 0,
            failed: 0,
            pending: 18,
            overall: 'Pending',
        },
        lastRunDate: '2024-01-12 09:15:33',
        nextRunDate: '-',
        createdBy: 'Sarah Wilson',
        module: 'Security',
    },
    {
        id: 'TG005',
        name: 'Shopping Cart Flow',
        description:
            'Complete shopping cart functionality testing including item management, quantity updates, and checkout process',
        groupType: 'Static',
        testCaseCount: 20,
        launchCount: 29,
        scheduledToRun: 'Yes',
        executionStatus: {
            passed: 20,
            failed: 0,
            pending: 0,
            overall: 'Passed',
        },
        lastRunDate: '2024-01-11 13:45:19',
        nextRunDate: '2024-01-18 08:00:00',
        createdBy: 'David Brown',
        module: 'Shopping',
    },
    {
        id: 'TG006',
        name: 'File Upload & Management',
        description:
            'File handling operations including upload, download, validation, virus scanning, and storage management',
        groupType: 'Dynamic',
        testCaseCount: 9,
        launchCount: 12,
        scheduledToRun: 'No',
        executionStatus: {
            passed: 6,
            failed: 1,
            pending: 2,
            overall: 'Mixed',
        },
        lastRunDate: '2024-01-10 15:22:41',
        nextRunDate: '-',
        createdBy: 'Lisa Davis',
        module: 'File Management',
    },
    {
        id: 'TG007',
        name: 'Test Group 7',
        description: 'Test Group 7 Description',
        groupType: 'Static',
        testCaseCount: 10,
        launchCount: 10,
        scheduledToRun: 'Yes',
        executionStatus: {
            passed: 10,
            failed: 0,
            pending: 0,
            overall: 'Passed',
        },
        lastRunDate: '2024-01-09 12:15:00',
        nextRunDate: '2024-01-19 07:00:00',
        createdBy: 'John Doe',
        module: 'Test Group 7',
    },
    {
        id: 'TG008',
        name: 'Test Group 8',
        description: 'Test Group 8 Description',
        groupType: 'Static',
        testCaseCount: 10,
        launchCount: 10,
        scheduledToRun: 'Yes',
        executionStatus: {
            passed: 10,
            failed: 0,
            pending: 0,
            overall: 'Passed',
        },
        lastRunDate: '2024-01-08 10:30:00',
        nextRunDate: '2024-01-20 06:00:00',
        createdBy: 'Jane Smith',
        module: 'Test Group 8',
    },
    {
        id: 'TG009',
        name: 'Test Group 9',
        description: 'Test Group 9 Description',
        groupType: 'Static',
        testCaseCount: 10,
        launchCount: 10,
        scheduledToRun: 'Yes',
        executionStatus: { 
            passed: 10,
            failed: 0,
            pending: 0,
            overall: 'Passed',
        },
        lastRunDate: '2024-01-07 09:15:00',
        nextRunDate: '2024-01-21 05:00:00',
        createdBy: 'John Doe',
        module: 'Test Group 9',
    },
    {
        id: 'TG010',
        name: 'Test Group 10',
        description: 'Test Group 10 Description',
        groupType: 'Static',
        testCaseCount: 10,
        launchCount: 10,
        scheduledToRun: 'Yes',
        executionStatus: {
            passed: 10,
            failed: 0,  
            pending: 0,
            overall: 'Passed',
        },
        lastRunDate: '2024-01-06 08:00:00',
        nextRunDate: '2024-01-22 04:00:00',
        createdBy: 'Jane Smith',    
        module: 'Test Group 10',        
    },
    {
        id: 'TG011',
        name: 'Test Group 11',
        description: 'Test Group 11 Description',
        groupType: 'Static',
        testCaseCount: 10,
        launchCount: 10,
        scheduledToRun: 'Yes',
        executionStatus: {
            passed: 10,
            failed: 0,
            pending: 0,
            overall: 'Passed',
        },
        lastRunDate: '2024-01-05 07:00:00',
        nextRunDate: '2024-01-23 03:00:00',
        createdBy: 'John Doe',
        module: 'Test Group 11',
    },
    {
        id: 'TG012',
        name: 'Test Group 12',
        description: 'Test Group 12 Description',
        groupType: 'Static',
        testCaseCount: 10,
        launchCount: 10,
        scheduledToRun: 'Yes',
        executionStatus: {  
            passed: 10,
            failed: 0,
            pending: 0,
            overall: 'Passed',
        },
        lastRunDate: '2024-01-04 06:00:00', 
        nextRunDate: '2024-01-24 02:00:00',
        createdBy: 'Jane Smith',
        module: 'Test Group 12',
    },
    {
        id: 'TG013',    
        name: 'Test Group 13',
        description: 'Test Group 13 Description',
        groupType: 'Static',
        testCaseCount: 10,
        launchCount: 10,
        scheduledToRun: 'Yes',  
        executionStatus: {
            passed: 10,
            failed: 0,
            pending: 0,
            overall: 'Passed',
        },  
        lastRunDate: '2024-01-03 05:00:00',
        nextRunDate: '2024-01-25 01:00:00',
        createdBy: 'John Doe',
        module: 'Test Group 13',
    },
        
    
];

export default mockTestGroups; 